import { Icon } from "../../components/BaseComponents/Icon";

export const CreditScoreGaugeIcon = (props) => (
	<Icon fill="none" viewBox="0 0 20 20" {...props}>
		<path
			d="M10 1.99988C5.58867 1.99988 2 5.58854 2 9.99988C2 14.4112 5.58867 17.9999 10 17.9999C14.4113 17.9999 18 14.4112 18 9.99988C18 5.58854 14.4113 1.99988 10 1.99988ZM5.33333 9.99988C5.33333 10.3679 5.03533 10.6665 4.66667 10.6665C4.298 10.6665 4 10.3679 4 9.99988C4 9.07521 4.21667 8.20254 4.59133 7.41921L5.60867 8.43654C5.43333 8.92588 5.33333 9.45121 5.33333 9.99988ZM10.9427 10.9425C10.6913 11.1945 10.356 11.3332 10 11.3332C9.644 11.3332 9.30867 11.1945 9.05733 10.9425C8.65533 10.5412 6.022 6.63054 5.72333 6.18588C5.63467 6.05388 5.652 5.87721 5.76467 5.76454C5.87733 5.65254 6.054 5.63521 6.186 5.72321C6.63067 6.02188 10.5413 8.65521 10.9427 9.05721C11.1947 9.30855 11.3333 9.64388 11.3333 9.99988C11.3333 10.3559 11.1947 10.6912 10.9427 10.9425ZM15.3333 10.6665C14.9647 10.6665 14.6667 10.3679 14.6667 9.99988C14.6667 7.42654 12.5727 5.33321 10 5.33321C9.45133 5.33321 8.92667 5.43321 8.43667 5.60854L7.42 4.59121C8.20267 4.21588 9.07533 3.99988 10 3.99988C13.3087 3.99988 16 6.69188 16 9.99988C16 10.3679 15.702 10.6665 15.3333 10.6665Z"
			fill="url(#paint0_linear_15716_19383)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_15716_19383"
				x1="10"
				y1="1.99988"
				x2="10"
				y2="17.9999"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
		</defs>
	</Icon>
);
